import * as React from 'react';
import ListBox from '../ListBox/ListBox';

import { List, ListItem, TopItem } from './ListTree.styles';

const ListTree = props => {
	const {
		data,
		total,
		colors,
		onChangeSelectionAll,
		onChangeCategorySelection,
	} = props;

	const getDataChunks = (data, chunkLength) => {
		return data.reduce((acc, item) => {
			if (acc.length === 0) {
				acc.push([]);
			}

			let currentChunk = acc[acc.length - 1];

			if (currentChunk.length === chunkLength) {
				acc.push([]);
			}

			currentChunk = acc[acc.length - 1];

			currentChunk.push(item);

			return acc;
		}, []);
	};

	let colsPerRow = 3;

	const chunks = getDataChunks(data, colsPerRow);
	return (
		<>
			<TopItem colsPerRow={colsPerRow}>
				<ListBox colors={colors} total={total} isTopItem />
			</TopItem>
			{chunks.map((chunkOfData, j) => (
				<List
					keepConnectorLine={chunks.length === 1}
					pairItemList={chunkOfData.length === 2}
					colsPerRow={colsPerRow}
					key={j}
				>
					{chunkOfData.map((dataItem, i) => (
						<ListItem key={i}>
							<ListBox
								index={i}
								colors={colors}
								colsPerRow={colsPerRow}
								total={{
									name: dataItem.name,
									value: dataItem.value,
									isSelectAll: dataItem.isSelectAll
								}}
								parentName={total.name}
								data={dataItem.data}
								onChangeSelectionAll={onChangeSelectionAll}
								onChangeCategorySelection={onChangeCategorySelection}
							/>
						</ListItem>
					))}
				</List>
			))}
		</>
	);
};

export default ListTree;
